up.compiler('[confirm-unsaved-changes=\'true\']', (element) => {
  const $element = $(element)
  window.unsavedChanges = false;

  let setUnsavedChangesFlagDestructor = up.watch($element, function () {
    window.unsavedChanges = true;
  });

  let removeUnsavedChangesFlagDestructor = up.on('up:form:submit', function () {
    window.unsavedChanges = false;
  });

  up.on('up:link:follow', confirmLeavingPage);
  up.on('up:layer:dismiss', confirmClosingModal);

  window.onbeforeunload = confirmRefreshingPage;

  function confirmLeavingPage(event) {
    if (window.unsavedChanges == true && !event.target.hasAttribute('up-layer') && !event.target.hasAttribute('disabled-unsaved-change-confirmation')) {
      loadConfirmDialog(event);
    }
  }

  function confirmClosingModal(event) {
    // we only want to confirm closing the modal if itself contains a form with unsaved changes
    if (window.unsavedChanges == true && $element.closest('up-modal').length > 0) {
      loadConfirmDialog(event);
    }
  }

  function confirmRefreshingPage() {
    if (window.unsavedChanges == true) {
      return 'Ungespeicherte Inhalte und Änderungen verwerfen?';
    }
  }

  function loadConfirmDialog(event) {
    let discardUnsavedChanges = window.confirm('Ungespeicherte Inhalte und Änderungen verwerfen?');

    if (discardUnsavedChanges == false) {
      event.preventDefault();
    } else {
      window.unsavedChanges = false;
    }
  }


  return () => {
    setUnsavedChangesFlagDestructor();
    removeUnsavedChangesFlagDestructor();
    up.off('up:link:follow', confirmLeavingPage);
    up.off('up:layer:dismiss', confirmClosingModal);
  }
})
